import { defineMessages } from 'react-intl';

const translations = {
  sections: {
    routes: {
      id: 'proxyForm.sections.routes',
      defaultMessage: 'Routes',
      description: 'label of the form field section routes',
    },
    cache: {
      id: 'proxyForm.sections.cache',
      defaultMessage: 'Cache',
      description: 'label of the form field section cache',
    },
    auth: {
      id: 'proxyForm.sections.auth',
      defaultMessage: 'Authentication',
      description: 'label of the form field section auth',
    },
  },
  fields: {
    path: {
      label: {
        id: 'properties.path',
        defaultMessage: 'Path',
        description: 'label of the form field path',
      },
    },
    uri: {
      label: {
        id: 'properties.uri',
        defaultMessage: 'URI',
        description: 'label of the form field uri',
      },
    },
    isBucket: {
      label: {
        id: 'properties.isBucket',
        defaultMessage: 'Bucket',
        description: 'label of the form field is bucket',
      },
    },
    isAsOrigin: {
      label: {
        id: 'properties.isAsOrigin',
        defaultMessage: 'As origin',
        description: 'label of the form field is as origin',
      },
    },
    isPublic: {
      label: {
        id: 'properties.isPublic',
        defaultMessage: 'Public',
        description: 'label of the form field is public',
      },
    },
    age: {
      label: {
        id: 'properties.age',
        defaultMessage: 'Age',
        description: 'label of the form field age',
      },
    },
    isRequired: {
      label: {
        id: 'properties.isRequired',
        defaultMessage: 'Required',
        description: 'label of the form field is required',
      },
    },
    scope: {
      label: {
        id: 'properties.scope',
        defaultMessage: 'Scope',
        description: 'label of the form field scope',
      },
    },
  },
  add: {
    id: 'actions.add',
    defaultMessage: 'Add',
    description: 'label of the add button',
  },
  remove: {
    id: 'actions.remove',
    defaultMessage: 'Remove',
    description: 'label of the remove button',
  },
};

export default defineMessages(translations);
